export default __webpack_public_path__ + "static/media/BSC Login Image.1e7599f4.png";